import { useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import { useParams } from 'react-router-dom';

export default function RenderAQuestion({ question,onSave,enableAnswer,label,index }) {
    const { id } = useParams();
    const { fontSize } = useSetting();
    const [isSelectingOption, setIsSelectingOption] = useState(false);
    const [selectedArea, setSelectedArea] = useState(enableAnswer ? fetchSavedAnswer() : null);
    const [studentAnswer, setStudentAnswer] = useState(enableAnswer ? fetchSavedAnswer() : null);
    

    function fetchSavedAnswer() {
        let savedAnswers = JSON.parse(sessionStorage.getItem(`answers-${id}`) || '{}');
         let answers = savedAnswers[`${label}`]||[]
         return answers[index]?.answer || null;
    }
    return (
        <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
            <div>{question?.question}</div>
            {
                question.type === '座標題1' ?
                    <div className='p-[8px] rounded-[8px] flex flex-row gap-[8px]'>
                        <div className='flex flex-1 flex-col bg-white items-center gap-[4px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                            <div>豁達／平靜</div>
                            <div className='flex flex-row w-full items-center gap-[4px]'>
                                <div>逃避／出世 </div>
                                <div className='flex flex-col flex-1 gap-[4px] relative'>
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('1');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '1' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('2');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '2' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                    </div>
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('3');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '3' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                        <button className='flex-1 bg-[#82828240]' style={{ aspectRatio: '17 / 12', height: undefined }} onClick={() => {
                                            if (isSelectingOption) {
                                                setSelectedArea('4');
                                                setIsSelectingOption(false);
                                            }
                                        }}>
                                            {isSelectingOption && <div className='glowingAnimation w-full h-full' />}
                                            {selectedArea === '4' && !isSelectingOption &&
                                                <button className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: '#EE8D59', color: 'white' }}>歐陽修</button>
                                            }
                                        </button>
                                    </div>
                                    {isSelectingOption && <div className='absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-[#EE8D59] bg-[white]'>點擊選擇區域</div>}
                                </div>
                                <div>面對／入世</div>
                            </div>
                            <div>悲憤／孤傲</div>
                        </div>
                        <div className='px-[8px]'>
                            <button onClick={() => { setIsSelectingOption(!isSelectingOption) }} className='px-[20px] py-[8px] rounded-[8px]' style={{ backgroundColor: isSelectingOption ? '#EE8D59' : '#82828240', color: isSelectingOption ? 'white' : 'black' }}>歐陽修</button>
                        </div>
                    </div>
                    :
                    question.type === '選擇題' ?
                        <div className='p-[8px] rounded-[8px] flex flex-col gap-[8px]'>
                            {question.options?.map((option, idx) => (
                                <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                    <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[6px] flex flex-row items-center noto-san-hk'>
                                        <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }} onClick={() => setStudentAnswer(option.option)} >
                                            {studentAnswer === option.option && <div className='w-full h-full bg-[#005B8C] rounded-full' />}
                                        </button>
                                        <span>{option.option}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        question.type === '互動題' ?
                            <div className='p-[8px] rounded-[8px] flex flex-col gap-[8px] w-full bg-[white] font-[400]'>
                                <div className='w-full flex flex-row justify-between items-center gap-[8px]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-1 flex-col gap-[2px]'>
                                        <div className='text-[#0044FF]'>歐陽修</div>
                                        <div>1 小時前【發佈動態】</div>
                                    </div>
                                    <button><img src='/secondary/more.png' alt='interaction' className='w-[28px]' /></button>
                                </div>
                                <div className='font-[400]'>剛被貶到滁州，心情本來有點悶，但看到這裡的風景，我突然領悟了……</div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                                <img className='w-full object-cover' src='/secondary/comments.png' alt='interaction' />

                                <div className='font-[400]' style={{fontSize:fontSize-4}}>回應</div>
                                 <div className='w-full flex flex-row justify-between items-center gap-[8px] font-[400]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-col gap-[2px] mr-[16px]'>
                                        <div className='text-[black]'>蘇軾</div>
                                    </div>
                                    <div className='flex-1 text-left'>
                                        前輩說得好！但如果要徹底不為貶謫感到痛苦，我的秘訣是換個角度看宇宙……
                                    </div>
                                </div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                                <div className='h-[1px] bg-[#ccc] w-full'/>
                                 <div className='w-full flex flex-row justify-between items-center gap-[8px] font-[400]'>
                                    <img src='/secondary/p1.png' alt='interaction' className='w-[77px] h-[77px]' />
                                    <div className='flex flex-col gap-[2px] mr-[16px]'>
                                        <div className='text-[black]'>范仲淹</div>
                                    </div>
                                    <div className='flex-1 text-left'>
                                        兩位的境界都很高，但身為讀書人，我們還有更重要的責任要扛！
                                    </div>
                                </div>
                                <div className='font-[400]'>引用我的名言：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                                <div className='font-[400]'>我的真實心聲：</div>
                                <textarea className='rounded-[8px] w-full p-[8px] border-[1px] border-[#ccc]' placeholder='請學生回答'/>
                            </div>
                            : <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={studentAnswer} onChange={(e) => setStudentAnswer(e.target.value)} />
            }
            <div className='flex flex-row justify-end'>
                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}
                    onClick={() => {
                        if(onSave){
                            let ans=''
                            if(question.type === '座標題1'){
                                ans = selectedArea
                            }else if(question.type === '選擇題'){
                                ans = studentAnswer
                            }else if(question.type === '短答題'){
                                ans = studentAnswer
                            }
                            onSave(ans) 
                        }
                    }} 
                >
                    儲存
                </button>
            </div>
        </div>
    )
}